import PropTypes from "prop-types";
import React from "react";

import styles from "../styles/components/PageLabel.css";

/**
 * Displays a page label (usually a capital letter) in a colored circle.
 * @param className (optional) a CSS className to apply to the outermost element.
 * @param color (optional) the color of the circle.
 * @param label {string} the page label.
 * @param props (optional) additional props to add to the outermost element.
 * @returns {*}
 * @constructor
 */
export default function PageLabel({ className, color, label, ...props }) {
    const style = color ? { background: color } : null;
    return (
        <div
            className={`${styles.pageLabel} ${className || ""}`}
            style={style}
            {...props}
        >
            <p className={styles.text}>{label}</p>
        </div>
    );
}

PageLabel.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    label: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/PageLabel.js